const API_PATH = {
  SEND_OTP: "/policy/prosure/customer/sendOTP",
  RESEND_OTP: "/policy/prosure/customer/resendOTP",
  VERIFY_OTP: "/policy/prosure/customer/authenticateOTP",
  CUSTOMER_DETAIL: "/policy/prosure/customer/homepage",
  SUPPORT: '/lead/contactUs',
  LIVELONG: '/third-party/liveLong/updateAndSSO',
};

export default API_PATH;
